export const roles =
{
    ADMIN: 'ADMIN',
    SUPER_ADMIN: 'SUPER_ADMIN',
    SURVEYOR: 'SURVEYOR',
}